import React from 'react'
import { com } from '@eidu/form'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import EntityFormDateField from './EntityFormDateField'
import Field = com.eidu.sharedlib.entity.field.Field

export type EntityFormDateInputProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField: (value: DraftFieldValue) => void
  error: boolean
}

const EntityFormDateInput = ({ field, fieldValue, updateField, error }: EntityFormDateInputProps) => (
  <EntityFormDateField field={field} fieldValue={fieldValue} updateField={updateField} error={error} />
)

export default EntityFormDateInput
